var render = function render(){var _vm=this,_c=_vm._self._c;return _c('bq-color-page',{attrs:{"nav-hidden":true}},[_c('div',{staticClass:"interaction-error__message mt-5"},[_vm._v(" "+_vm._s(_vm.errorMessages[_vm.interactionError.errorKey])+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }